import React, { useState, useCallback, useEffect } from 'react';
import './App.less';
import { HashRouter } from 'react-router-dom';
import PageHeader from './components/PageHeader'
import PageFooter from './components/PageFooter'
import FloatTel from './components/FloatTel'
import ShowRecord from './components/ShowRecord'
import Banner from "./components/Banner";
import Context from './context/Context'
import Routes from './router'
import { getUserTicketForCheckIsLogin } from './utils/loginStatus'
import { initApp } from './common/init'
import { message, Modal } from 'antd'
import { globalData } from './common/config'
import { Record } from './utils/rrweb'

import { getProductInfo, getAmazonProductType, getTargetInfoByPlaceType } from './common/api'
import { async } from 'q';
interface DefaultAddress {
  cityCode: String,
  departmentCode: String
  address: object[]
}
interface AddressInfo {
  hint: boolean;
}
interface DefaultPlaceType {
  locationType1: String,
  locationType2: String,
  locationType3: String,
  locationType4: String
}
interface DefaultDutyAmount {
  value: string,
  code: string
}
let excludeAreaList = globalData['appProductInfo']['excludeAreaList']

const formatTargetFormList = (list: any[]) => {
  return list.map(item => {
    let type = 'input-target';
    let dataList = [];
    if (item.propertyType === 'text') {
      type = 'input-target';
    } else if (item.propertyType === 'select') {
      type = 'select-target';
    }
    if (item.dataList) {
      dataList = item.dataList.map(data => {
        return {
          label: data.valueChineseName || '',
          value: data.valueCode || ""
        }
      })
    }
    return {
      label: item.propertyName,
      name: item.propertyKey,
      type: type,
      items: [
        { defaultValue: '', addonBefore: '', addonAfter: '' },
      ],
      data: dataList || [],
      min: item.minValue,
      max: item.maxValue,
      rules: [
        { required: item.isRequire || false, message: '请输入' + item.propertyName }
      ],
      isShow: true
    }
  })
}
const App: React.FC = () => {
  const isAliProduct = globalData['aliProductCodes'].includes(globalData['productCode']);
  if (isAliProduct) {
    require("./orangeTheme.less")
  } else {
    require("./App.less")
  }
  const [targetFormList, setTargetFormList] = useState<object[]>([])
  const setTargetForm = (list:any[]) => {
    setTargetFormList(list);
  }
  //挂在全局contenxt
  //登陆态
  const [isLogin, setIsLogin] = useState(getUserTicketForCheckIsLogin())
  const setLogin = useCallback((isLogin: boolean) => {
    setIsLogin(isLogin)
  }, [])
  // 隐藏投保录屏提示框 
  const [notDialogInsure, setNotDialogInsure] = useState(false)

  // P060030投保须知与table联动
  const [needKnowKeyOne, setNeedKnowKeyOne] = useState("");
  const [needKnowKeyTwo, setNeedKnowKeyTwo] = useState("");
  const setNeedKnow = (key: string, value: string) => {
    if (key === "one") {
      setNeedKnowKeyOne(value);
    }
    if (key === "two") {
      setNeedKnowKeyTwo(value);
    }
  }

  let selectedPlans:any = ["PL1000002", "PL1800205", "PL1000006"];
  let planOptions = [
    { value: "PL1000002", label: "财产一切险" },
    { value: "PL1800205", label: "团体意外险" },
    { value: "PL1000006", label: "公众责任保险" },
  ]
  globalData["planCheckboxOptions"] = planOptions;
  const [selectedPlan, setSelectedPlan] = useState<string[]>(selectedPlans);
  const [planCheckboxOptions, setPlanCheckboxOptions]= useState<object[]>(planOptions);
  const setPlan = (keys: any[]) => {
    setSelectedPlan(keys);
  };
  const setPlanOptions = (keys: any[]) => {
    setPlanCheckboxOptions(keys);
    globalData["planCheckboxOptions"] = keys;
  };

  const [professionList, setProfessionList] = useState<object[]>([])
  const setProfessionListFunc = (list: any[]) => {
    setProfessionList(list);
  }

  // P040032添加健康告知
  const [healthNoticeOpen, setHealthNoticeOpen] = useState(false)
  const setHealthNoticeOpenFunc = (open: boolean) => {
    setHealthNoticeOpen(open);
  }

  //记录input-mutil的数据用于与table联动
  const [tableRely, setTableRely] = useState({})
  const setTable = (key: string, value: string | number) => {
    const new_tableRely = Object.assign(tableRely)
    new_tableRely[key] = value
    setTableRely(new_tableRely)
  }

  //记录工程造价的数据用于与table联动
  const [projectCostValue, setProjectCostValue] = useState<string|number>("")
  const setProjectCost = (value: number|string) => {
    setProjectCostValue(value)
  }

  //地址数据
  const [addressList, setAddressList] = useState<object[]>([])
  const [initFlag, SetInitFlag] = useState(false)
  const setInitSuccess = () => {
    SetInitFlag(true)
  }

  //套餐选择数据
  const [selectedSet, setSelectedSet] = useState(0)
  const setSet = (set: number) => {
    globalData['selectedSet'] = set
    setSelectedSet(set)
  }
  const [addressInfo, setAddressInfo] = useState<AddressInfo>({ hint: false })
  const [productTypeData, setProductTypeData] = useState<any>([]);

  const [needAddressFresh, setNeedAddressFresh] = useState(false)
  //默认地址
  const [againInit, setAgainInit] = useState(false)
  let defaultCity = { cityCode: '310119', departmentCode: '2022003', countyName: "" };
  if (globalData["productCode"] == "P060028") {
    defaultCity.cityCode = "110101";
    defaultCity.departmentCode = "20127";
    // globalData["defaultAddress"] = ["110000_北京市", "110100_北京市", "110101_东城区"];
  } else if (globalData["productCode"] == "P060029") {
    defaultCity.departmentCode = "2022003";
    defaultCity.cityCode = "310100";
    //globalData["defaultAddress"]=["310000_上海市", "310100_上海市", "310119_南汇区"];
  } else if (globalData["productCode"] == "P060034" || globalData["productCode"] == "P060036") {
    defaultCity.departmentCode = "23203";
    defaultCity.cityCode = "410300";
  } else if (isAliProduct) {
    defaultCity.cityCode = "";
  }
  const [defaultAddress, setDefaultAddress] = useState<object>(defaultCity)
  const handleChooseAddress = (res: DefaultAddress) => {
    setDefaultAddress(res)
    if (window.location.hash.includes('#/order') === false) {
      SetInitFlag(false)
      //setAgainInit(false);
      setNeedAddressFresh(false);
      getProductInfo(res).then((data) => {
        if (data['data']['resultCode'] == "Z0101001") {
          globalData['appProductInfo'] = data.data.data;
          globalData['selectedSet'] = selectedSet;
          if (globalData['productCode'] === 'P060090') {
            // 根据链接参数只展示一个套餐
            if (globalData['appProductInfo'] && globalData['appProductInfo']['packageList']) {
              const gUrlPackType = globalData["gUrlData"]["packType"] || "1";
              globalData['appProductInfo']['packageList'] = globalData['appProductInfo']['packageList'].filter((p, index) => {
                if (gUrlPackType === "1") {
                  return index === 0;
                } else if (gUrlPackType === "2") {
                  return index === 1;
                } else if (gUrlPackType === "3") {
                  return index === 2;
                }
                return index === 0;
              });
            }
          }
          // 设置标的信息
          const targetPropertyList = JSON.parse(JSON.stringify(globalData['appProductInfo']['targetPropertyList'] || []));
          globalData["targetFormList"] = formatTargetFormList(targetPropertyList);
          setTargetFormList(JSON.parse(JSON.stringify(globalData["targetFormList"])));
          excludeAreaList = globalData['appProductInfo']['excludeAreaList'];
          const exclude = globalData['appProductInfo']['excludeAreaList']
          const excludeCode = exclude.map((item) => {
            return { provice: item['provice'], city: item['city'], county: item['county'] }
          })
          globalData['excludeFlag'] = false
          //setAgainInit(true);
          for (const excludeItem of excludeCode) {
            //判断只有省级地区的情况
            if (!excludeItem['county'] && !excludeItem['city'] && excludeItem['provice'] === res.address[0]['code']) {
              globalData['excludeFlag'] = true
              break
            }
            //判断只到区级地区的情况
            if (!excludeItem['county'] && excludeItem['city'] === res.address[1]['code']) {
              globalData['excludeFlag'] = true
              break
            }
            //判断县级地区的情况
            else if (excludeItem['county'] === res.address[2]['code']) {
              globalData['excludeFlag'] = true
              break
            }
          }
          //在未发行地区或者该地区没有departCode的时候不予报价
          if (globalData['excludeFlag'] || !globalData['dpt'][res.address[1]['code']]) {
            setAddressInfo({ hint: true })
            SetInitFlag(true)
            return
          }
          setAddressInfo({ hint: false })
          SetInitFlag(true)
        } else {
          message.error('获取套餐信息失败,请稍后再试');
        }
      }).catch((e) => {
        console.log(e)
        SetInitFlag(true)
        setAddressInfo({ hint: true })
        message.error('获取该地区套餐失败')
      })//获取产品信息

    }
  }
  // 切换场所类型之后的回调
  const handleChoosePlaceType = async (res: DefaultPlaceType) => {
    const targetPropertyList = JSON.parse(JSON.stringify(globalData['appProductInfo']['targetPropertyList'] || []));
    const values = Object.values(res).filter(item => item);
    if (values.length > 0) {
      await getTargetInfoByPlaceType(res).then(result => {
        const responseBody = result['data'];
        if (responseBody['resultCode'] == "00") {
          globalData["locationTypeToRisks"] = responseBody['data']['locationTypeToRisks'] || [];
          globalData["targetFormList"] = filterTargetList(globalData["locationTypeToRisks"], globalData["planDuty"]);
        } else {
          message.error('重置标的信息失败');
        }
        setTargetFormList(JSON.parse(JSON.stringify(globalData["targetFormList"])))
      })
    } else {
      // 场所类型置为空，默认展示所有标的
      globalData["targetFormList"] = formatTargetFormList(targetPropertyList);
      setTargetFormList(JSON.parse(JSON.stringify(globalData["targetFormList"])))
    }
  }

  // 根据现有的场所类型和保额设置筛选标的信息
  const filterTargetList = (keyList: any[], planDuty: any[]) => {
    // 过滤责任套餐中的“附加电梯责任”，“附加停车场责任”，“附加游泳池责任”
    const isNeedLift = planDuty.find(item => item.dutyCode === "CV02289");
    const isNeedPark = planDuty.find(item => item.dutyCode === "CV02291");
    const isNeedPool = planDuty.find(item => item.dutyCode === "CV02292");
    return globalData["targetFormList"].map(item => {
      if (
        keyList.includes(item.name)
        || (item.name === "liftNumber" && isNeedLift)
        || (item.name === "parkingNumber" && isNeedPark)
        || (item.name === "poolNumber" && isNeedPool)
      ) {
        item.isShow = true;
      } else {
        item.isShow = false;
      }
      return item;
    });
  }

  // 切换套餐后的回调
  const handleChoosePackage = (set: number) => {
    globalData["targetFormList"] = filterTargetList(globalData["locationTypeToRisks"], globalData["planDuty"]);
    setTargetFormList(JSON.parse(JSON.stringify(globalData["targetFormList"])))
  }
  //当地区不支持该险种时 用于展示单独的地区输入框

  useEffect(() => {
    const initFun = async () => {
      const { productCode, teamAccidentProds } = globalData;
      // 是否是团意产品
      const isTeamAccidentProd = teamAccidentProds.includes(productCode);
      // 非order页面初始化产品
      if (window.location.hash.includes('#/orderAli')) {
        setNotDialogInsure(true)
      } else if (window.location.hash.includes('#/order') === false) {
        initApp(defaultAddress).then((res) => {
          const data = res.data;
          if (data.appInitData.resultCode === 'A0301003') {
            setNotDialogInsure(true)
            Modal.error({
              title: '温馨提示',
              content: data.appInitData.resultMsg,
              okButtonProps: { style: { display: 'none' } }
            })
            return
          }
          setAddressList(data.address)
          if (!res.result) {
            setNeedAddressFresh(true)
            message.error('获取产品信息失败')
            return
          }
          globalData['appProductInfo'] = data.appProductInfo;
          // 团意产品行业信息需单独接口查询并存于teamIndustryList 
          if (isTeamAccidentProd) {
            globalData['teamIndustryList'] = data.teamIndustryList || [];
          } else if (globalData['productCode'] === 'P060090') {
            // 根据链接参数只展示一个套餐
            if (globalData['appProductInfo'] && globalData['appProductInfo']['packageList']) {
              const gUrlPackType = globalData["gUrlData"]["packType"] || "1";
              globalData['appProductInfo']['packageList'] = globalData['appProductInfo']['packageList'].filter((p, index) => {
                if (gUrlPackType === "1") {
                  return index === 0;
                } else if (gUrlPackType === "2") {
                  return index === 1;
                } else if (gUrlPackType === "3") {
                  return index === 2;
                }
                return index === 0;
              });
            }
          }
          // 标旳信息
          const targetPropertyList = JSON.parse(JSON.stringify(globalData['appProductInfo']['targetPropertyList'] || []))
          globalData["targetFormList"] = formatTargetFormList(targetPropertyList);
          setTargetFormList(JSON.parse(JSON.stringify(globalData["targetFormList"])));
          globalData['selectedSet'] = selectedSet
          SetInitFlag(true)
        })
        if (productCode == "P060028") {
          globalData["defaultAddress"] = ["110000_北京市", "110100_北京市", "110101_东城区"];
          var pTypeData: any = [], disabledCode: any = [];
          getAmazonProductType().then((res) => {
            if (res.data instanceof Array) {
              res.data.forEach((l: any) => {
                if ("0" === l.operateType) {
                  disabledCode.push(l.levelsCode)
                } else if ("1" == l.operateType && l.lastLevelsCode == l.classCode) {
                  pTypeData.push(l);
                }
              })

              pTypeData.forEach((p) => {
                res.data.find(item => {
                  if (p.levelsCode == item.lastLevelsCode) {
                    p.children == undefined ? p.children = [item] : p.children.push(item);
                  }
                })
              })
            }

            setProductTypeData([...pTypeData])
          });
        } else if (productCode == "P060034" || productCode == "P060036") {
          globalData["defaultAddress"]=["410000_河南省", "410300_洛阳市", "410329_伊川县"];
        } else if (isAliProduct) {
          globalData["defaultAddress"]=[];
        }
      }
    }
    initFun()
  }, [])

  useEffect(() => {
    try {
      if (globalData["productCode"] === "P060030" || globalData["productCode"] === "P060039") {
        globalData["needKnow"] = { needKnowKeyOne, needKnowKeyTwo };
        // 监测到checkbox options变化或者checkbox 选中项变化
        const newOptionsValue = planCheckboxOptions.map(option => option["value"]);
        const newSelected = selectedPlan.filter(select => newOptionsValue.includes(select));
        globalData["selectedCheckbox"] = [].concat(newSelected as any);
      }
    } catch (e) {
      console.log("出错了");
    }
  }, [needKnowKeyOne, needKnowKeyTwo, selectedPlan, planCheckboxOptions])

  // 使用 useState 来管理 isRecording 状态
  const [isRecording, setIsRecording] = useState(true);

  useEffect(() => {
    if (location.hostname === "localhost") {
      // 本地环境不需要录屏
      return;
    }
    
    try {
      let pageId = window.location.hash || "";
      if (pageId.includes('?')) {
        pageId = pageId.split('?')[0];
      }

      if (pageId && pageId.length > 32) {
        pageId = pageId.substring(0, 32);
      }

      const record = new Record(
        {
          policyNo: "", // 保单号
          applyPolicyNo: "", // 投保单号
          transNo: "", // 交易号
          sysId: "pa18-shop-nst", // 对接系统
          pageId: pageId, // 页面ID
          version: "v1.0", // 系统版本
          dataFlag: "0", //"0"是录屏 "1"截屏
          insuranceFlag: "1", // 0：车险 1：非车 2：团
          sceneFlag: "0" // 场景字段: 0:出单;1:批改；2:自助卡激活,3：财务
        },
        {
          replayZone: "replay-zone",
          autoSave: true
        }
      )
  
      record.addInsuranceCheckRule(isRecording)
  
      if (isRecording) {
        //记录
        let interval = setInterval(() => {
          const transNo = globalData['flowId']
          console.log("transNo>>>>>>>", transNo)
          if (transNo) {
            record.setTransNo(transNo);
            clearInterval(interval)
            setTimeout(() => {
              setIsRecording(true)
              record.start()
            }, 2000)
          }
        }, 1500)
      } else {
        // 停止录制
        if (record) {
          record.save()
          record.stop(() => {
            setIsRecording(false)
            console.log("屏幕录制已经停止！")
          })
        }
      }
  
      // 清理函数，组件卸载时停止录制
      return () => {
        if (record) {
          record.stop({});
        }
      };
    } catch (e) {
      console.log("产品记录系统异常");
    }
  }, [isRecording]); // 监听 isRecording 状态的变化

  return (
    <Context.Provider value={{
      isLogin: isLogin,
      setIsLogin: setLogin,
      needKnow: {needKnowKeyOne, needKnowKeyTwo},
      selectedPlan: selectedPlan,
      setSelectPlan: setPlan,
      planCheckboxOptions: planCheckboxOptions,
      setPlanOptions: setPlanOptions,
      setNeedKnow: setNeedKnow,
      tableRely: tableRely,
      setTableRely: setTable,
      setProjectCost: setProjectCost,
      projectCost: projectCostValue,
      addressList: addressList,
      targetFormList: targetFormList,
      setTargetForm: setTargetForm,
      productTypeData: productTypeData,
      documentGroupIdList: [],
      initFlag: initFlag,
      setInitSuccess: setInitSuccess,
      selectedSet: selectedSet,
      setSelectedSet: setSet,
      needAddressFresh: needAddressFresh,
      handleChooseAddress: handleChooseAddress,
      handleChoosePlaceType: handleChoosePlaceType,
      handleChoosePackage: handleChoosePackage,
      addressInfo: addressInfo,
      professionList: professionList,
      setProfessionList: setProfessionListFunc,
      healthNoticeOpen: healthNoticeOpen,
      setHealthNoticeOpen: setHealthNoticeOpenFunc
    }}>
      <React.Fragment>
        {!isAliProduct && <PageHeader />}
        {!notDialogInsure && <ShowRecord />}
        {isAliProduct && <Banner></Banner>}
        <HashRouter>
          <Routes />
        </HashRouter>
        {!isAliProduct && <PageFooter />}
        {isAliProduct && <FloatTel />}
      </React.Fragment>
    </Context.Provider>
  );
}

export default App;
